import React, { useState } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ShareIcon from '@material-ui/icons/Share';
import { ShareMachineDialog } from './ShareMachineDialog';

export default connect(({ machine }) => ({ machineId: machine.id }))((props) => {
	const [open, setOpen] = useState(false);
	const showDialog = (doIt) => (ev) => {
		ev.stopPropagation();
		setOpen(doIt);
	};

	return (
		<MenuItem dense onClick={showDialog(true)}>
			<ListItemIcon>
				<ShareIcon fontSize="default" />
			</ListItemIcon>
			<ListItemText
				primary={<FormattedMessage id="Extensions.ShareMachine.Tooltip" defaultMessage="Share App" />}
			/>
			<ShareMachineDialog machineId={props.machineId} open={open} onClose={showDialog(false)} />
		</MenuItem>
	);
});



// WEBPACK FOOTER //
// /home/travis/build/cedalo/streamsheets-pro-features/packages/webui-extensions/src/sharemachine/ShareMachineMenuItem.js